import React, { Component, useEffect, useState, useRef, createRef } from 'react'
import { useIonAlert } from '@ionic/react'
import { useLocation } from 'react-router'
import {
    Grid,
    Typography,
    Drawer,
    Toolbar,
    Divider,
    Box,
    Stack,
    CssBaseline,
    List,
    ListItem,
    Avatar,
    Slider,
    Button,
} from '@mui/material'
import * as Loaders from '../../components/UIComponents/Loader'
import * as Icons from '../../components/UIComponents/Icons'
import * as Buttons from '../../components/UIComponents/Button'
import * as IconButtons from '../../components/UIComponents/IconButtons'
import * as Texts from '../../components/UIComponents/Text'
import * as Images from '../../components/UIComponents/Images'
import * as Forms from '../../components/UIComponents/Form'
import AppNavigator2 from '../../components/AppNavigator2'
import DotIndicator from './DotIndicator'
import LeftProgressPanel from './LeftProgressPanel'
import MustAsterik from './MustAsterik'

import config from '../../config/config'

// import the keyvalue pair component that is shared within the ProfileSetup page
import KeyValuePairs from './KeyValuePairComponent'
import BotHelper from '../../helpers/BotHelper'
import { v4 as uuidv4 } from 'uuid'


const LifeDetails = ({
    children,
    history,
    bot,
    updateBotProfileBulk,
    updateBotProfile,
    selectedDot,
    setSelectedDot,
    dict,
    resetSession
}) => {
    const [error, setError] = useState({})
    const [presentAlert] = useIonAlert()
    const [big5Values, updateBig5Values] = useState({
        big5Practicality: 50,
        big5Flexibility: 50, 
        big5Introversion: 50,
        big5Independence: 50,
        big5Composure: 50,
    })
    const [storyObj, setStoryObj] = useState([])
    const [backgroundObj, setBackgroundObj] = useState([])
    const [personalityObj, setPersonalityObj] = useState([])
    const prevBackgroundDataRef = useRef(null)
    const prevStoryDataRef = useRef(null)
    const prevPersonalityDataRef = useRef(null)

    // this locks the useEffect so it only gets fired when users are in this page
    const location = useLocation();
    const isActive = location.pathname === '/profilesetup/life-details';

    const big5ValuesOptions = [
        { key: "big5Practicality", dictKey: "practicality" },
        { key: "big5Flexibility",  dictKey: "flexibility" },
        { key: "big5Introversion", dictKey: "introversion" },
        { key: "big5Independence", dictKey: "independence" },
        { key: "big5Composure",    dictKey: "composure" },
    ]



    function isValidData() {
        const errors = {}
        const story = storyObj
        console.log("story", story)
        if (story.some(val => {
            return typeof val === 'object' && (
                (val.type === undefined || val.type.trim() === '') ||
                (val.detail === undefined || val.detail.trim() === '')
            )
        })) {
            errors.story = dict["storyIncompleteError"]
        }

        const background = backgroundObj
        if (background.some(val => {
            return typeof val === 'object' && (
                (val.type === undefined || val.type.trim() === '') ||
                (val.detail === undefined || val.detail.trim() === '')
            )
        })) {
            errors.background = dict["backgroundIncompleteError"]
        }

        // const personality = personalityObj
        // if (personality.some(val => {
        //     return typeof val === 'object' && (
        //         (val.type === undefined || val.type.trim() === '') ||
        //         (val.detail === undefined || val.detail.trim() === '')
        //     )
        // })) {
        //     errors.personality = dict["personalityIncompleteError"]
        // }
        // console.log("errors: ", errors)
        setError(errors)
        return errors
    }

    function isBig5Valid(big5Values) {
        const allValuesAreDefault = Object.values(big5Values).every((value) => value === 50)
    
        if (allValuesAreDefault) {
            return new Promise((resolve) => {
                presentAlert({
                    header: dict["alertTitle"],
                    message: dict["big5AllDefaultConfirmation"],
                    buttons: [
                        {
                            text: dict["big5Cancel"],
                            role: "cancel",
                            handler: () => {
                                resolve(false)
                            },
                        },
                        {
                            text: dict["big5Continue"],
                            handler: () => {
                                resolve(true)
                            },
                        },
                    ],
                })
            })
        }
    
        return Promise.resolve(true)
    }
    
    

    function showFirstError(errors) {
        const firstErrorField = Object.keys(errors)[0]
        if (firstErrorField) {
            presentAlert({
                header: dict["alertTitle"],
                message: errors[firstErrorField],
                buttons: ["OK"]
            })
        }
    }

    const clearError = (field) => {
        setError((prevErrors) => {
            const updatedErrors = { ...prevErrors }
            delete updatedErrors[field]
            return updatedErrors
        })
    }
    

    function insertBig5Data(){
        updateBotProfileBulk({
            profileObj: {
                ...bot.profileObj,
                longMem: {
                    ...bot.profileObj.longMem,
                    ...big5Values,
                },
            },
        })
    }

    useEffect(() => {
        if(!isActive) return;
        // console.log("the loaded bot profile is ", bot?.profileObj)
        const processKeyValueData = (ymlString, setObjState, prevRef, existingObjArrFromRedux) => {
            
            // console.log("to parse keyvalue ", ymlString)
            let finalArray = []

            if (existingObjArrFromRedux && Array.isArray(existingObjArrFromRedux) && existingObjArrFromRedux.length > 0 && existingObjArrFromRedux[0].id) {
                finalArray = existingObjArrFromRedux.map(item => {
                    // console.log("existing obj from redux looped item", item)
                    return {
                        id: item.id || uuidv4(),
                        type: String(item.type || ''),
                        detail: String(item.detail || '')
                    }
                })
            } else {
                let currentParsed = []
                try {
                    if (ymlString && typeof ymlString === 'string' && ymlString !== '0') {
                        let tempParsed = BotHelper.paresYmlString(ymlString)
                        if (Array.isArray(tempParsed) && tempParsed.length > 0) {
                            currentParsed = tempParsed.map(item => {
                                // console.log("looped item", item)
                                const type = (item && typeof item === 'object' && item.type) ? String(item.type) : ''
                                const detail = (item && typeof item === 'object' && item.detail) ? String(item.detail) : ''
                                return { type: type, detail: detail }
                            })
                        }
                    }
                } catch (e) {
                    console.error("LifeDetails: Error parsing YML or processing data:", e)
                    currentParsed = []
                }

                if (currentParsed.length > 0) {
                    
                    finalArray = currentParsed.map(item => {
                        // console.log("current parsed is larger", item)
                        return {
                            id: uuidv4(),
                            type: item.type,
                            detail: item.detail
                        }
                    })
                    // console.log("final array is ", finalArray)
                } else {
                    finalArray = [{ id: uuidv4(), type: "", detail: "" }]
                }
            }
            const currentDataForComparison = finalArray.map(({ type, detail }) => ({ type, detail }))
            if (prevRef.current && JSON.stringify(prevRef.current) === JSON.stringify(currentDataForComparison)) {
                return false
            }
            setObjState(finalArray)
            prevRef.current = currentDataForComparison
            return true
        }
        // console.log("the background yml string is", bot?.profileObj?.background)
        processKeyValueData(
            bot?.profileObj?.background,
            setBackgroundObj,
            prevBackgroundDataRef,
            bot?.profileObj?.backgroundObj
        )

        processKeyValueData(
            bot?.profileObj?.story,
            setStoryObj,
            prevStoryDataRef,
            bot?.profileObj?.storyObj
        )

        processKeyValueData(
            bot?.profileObj?.personality,
            setPersonalityObj,
            prevPersonalityDataRef,
            bot?.profileObj?.personalityObj
        )
        if (bot["profileObj"].hasOwnProperty("longMem") && typeof bot["profileObj"]["longMem"] !== "string" && bot["profileObj"]["longMem"] !== "") {
            // console.log("2",bot["profileObj"]["longMem"])
            if(bot["profileObj"]["longMem"].hasOwnProperty("big5Practicality")){
                updateBig5Values(bot["profileObj"]["longMem"])
            }
            else{insertBig5Data()}
        }
        else{insertBig5Data()}

    }, [
        isActive,
        bot?.profileObj?.background,
        bot?.profileObj?.story,
        bot?.profileObj?.personality,
        bot?.profileObj?.longMem,
        bot?.profileObj?.backgroundObj,
        bot?.profileObj?.storyObj,
        bot?.profileObj?.personalityObj
    ])
  
    return (<React.Fragment>
        <AppNavigator2
            title={dict["pageTitle"]} 
            onBackClicked={() => {
                presentAlert({
                    header: dict["isBackToLoginTitle"],
                    message: dict["isBackToLoginMessage"],
                    buttons: [
                        {
                            text: dict["cancelText"],
                            role: "cancel"
                        },
                        {
                            text: dict["yesText"],
                            handler: () => {
                                // resetSession()
                                return history.push('/')
                            }
                        }
                    ]
                })
                return false
            }}

            onBackToChatRoomClicked={
                bot?.id && bot?.profileObj?.isEditProfile === true ?  () => { 
                    presentAlert({
                        header: dict["isBackToChatRoomTitle"],
                        message: dict["isBackToChatRoomMessage"],
                        buttons: [
                            {
                                text: dict["cancelText"],
                                role: "cancel"
                            },
                            {
                                text: dict["yesText"],
                                handler: () => {
                                    return history.push('/chatroom/pdfbot');
                                }
                            }
                        ]
                    })
                } : null
            }
        />
        <Grid container
            direction={{
                xs: "column",
                md: "row"
            }}
            sx={{
                flex: 1,
                bgcolor: 'background.gray',
                height: `calc(100vh - ${config.headerHeight}px)`,
                overflowY: {
                    xs: "scroll",
                    md: "hidden"
                }
            }}
        >
            {/** The left image and progress indicator */}
            <Grid item
                sx={{
                    flex: {
                        xs: .2,
                        sm: .2,
                        md: 1
                    },
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: {
                        sm: 'center',
                        md: "flex-start"
                    },
                    alignItems: "center"
                    // bgcolor: 'background.default'
                }}
            >
                {/*<Stack
                    direction={"column"}
                    justifyContent={{
                        xs: "center",
                        lg: "flex-start"
                    }}
                    alignItems={"center"}
                    spacing={4}
                    sx={{
                        // bgcolor: 'background.dark',
                        width: 1,
                        px: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        },
                        py: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        }
                    }}
                >
                    <Texts.H4
                        sx={{
                            color: 'primary.dark'
                        }}
                    >Avatar Profile Setup</Texts.H4>
                    <Texts.Tip>In this section, you will be guided through the profile setup steps. The whole process can take up to 10 minutes.</Texts.Tip>
                    <Box
                        sx={{
                            width: '240px',
                            display: {
                                xs: 'none',
                                md: 'block'
                            }
                        }}
                    >
                        <Images.LifeDetails />
                    </Box>
                    <DotIndicator selectedDot={selectedDot} setSelectedDot={setSelectedDot} />
                </Stack>*/}
                {/*<LeftProgressPanel history={history} selectedDot={selectedDot} setSelectedDot={setSelectedDot} />*/}
                {children}

            </Grid>
            <Grid item
                sx={{
                    flex: 1,
                    height: {
                        md: 1
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: "flex-start",
                    alignItems: "center",
                    bgcolor: 'background.default',
                    overflowY: {
                        xs: "scroll",
                        md: "scroll"
                    }
                }}
            >
                <Stack
                    spacing={2}
                    direction={"column"}
                    sx={{
                        width: 1,
                        px: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        },
                        py: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        }
                    }}
                >
                    <Box>
                        <Texts.Tip><MustAsterik />{`${dict["asterik"]}`}</Texts.Tip>
                    </Box>
                    {/* <Texts.H4
                        sx={{
                            mb: {
                                xs: 4,
                                md: 6
                            },
                            color: 'primary.dark',
                            whiteSpace: 'pre-line'
                        }}
                    >{dict["sectionTitle"]}</Texts.H4> */}
                    {/* <Texts.Paragraph>
                    {dict["sectionExplain"]} 
                    </Texts.Paragraph> */}
                    {/* <Divider /> */}

                    {/* 共通の記憶（最大6組） */}
                    <Texts.H6>{dict["background"]}<MustAsterik /></Texts.H6>
                    <Texts.Paragraph>
                        {dict["backgroundHelpingText"]}
                        
                    </Texts.Paragraph>
                    
                    <KeyValuePairs
                        targetTheme={dict["backgroundTargetTheme"]}
                        inputJsonArr={backgroundObj}
                        enableCustomType={true}
                        useAutocomplete={true}
                        isMultiline={true}
                        predefinedTypes={dict["backgroundTypeOptions"]}
                        typeLabel={dict["typeLabel"]}
                        detailLabel={dict["detailLabel"]}
                        maxWarning={dict["maxWarning"]}
                        deleteWarning={dict["deleteWarning"]}
                        cancelText={dict["cancelText"]}
                        yesText={dict["yesText"]}
                        onUpdateArr={(newArr) => {
                            updateBotProfileBulk({
                                profileObj: {
                                    background: BotHelper.convertJsonToYmlString(newArr),
                                    backgroundObj: newArr
                                }
                            })
                            
                            clearError("background")
                        }}
                    />

                    {/* やり残したこと（最大6組） */}
                    <Texts.H6>{dict["story"]}<MustAsterik /></Texts.H6>
                    <Texts.Paragraph>
                        {dict["storyHelpingText"]}
                    </Texts.Paragraph>

                    <KeyValuePairs
                        targetTheme={dict["storyTargetTheme"]}
                        inputJsonArr={storyObj} 
                        enableCustomType={true}
                        useAutocomplete={true}
                        isMultiline={true}
                        predefinedTypes={dict["storyTypeOptions"]}
                        typeLabel={dict["typeLabel"]}
                        detailLabel={dict["detailLabel"]}
                        maxWarning={dict["maxWarning"]}
                        deleteWarning={dict["deleteWarning"]}
                        cancelText={dict["cancelText"]}
                        yesText={dict["yesText"]}
                        onUpdateArr={(newArr) => {
                            console.log("story array", newArr)
                            // updateStory(newArr)
                            updateBotProfileBulk({
                                profileObj: {
                                    story: BotHelper.convertJsonToYmlString(newArr),
                                    storyObj: newArr
                                }
                            });
                        }}
                    />

                    {/* 性格特性 */}
                    <Box>
                        <Texts.H6>{dict["big5"]}<MustAsterik /></Texts.H6>
                        <Texts.Paragraph>{dict["big5HelpingText"]}</Texts.Paragraph>
                        {big5ValuesOptions.map((item) => {
                            const leftPercentage = big5Values[item.key]
                            const rightPercentage = 100 - big5Values[item.key]
                            return (
                                <Box key={item.key} 
                                    sx={{ 
                                        mb: 3,
                                        display: 'flex', 
                                        // gap: 2,
                                        flexDirection: 'column'
                                        }}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-end', 
                                        width: '100%',
                                    }}>

                                        {/*<Box sx={{ display: 'flex', alignItems: 'baseline', gap: 2 }}> 
                                            <Typography sx={{ flexShrink: 0 }}>
                                                {dict.big5Options[item.dictKey]?.left}
                                            </Typography>
                                            <Typography variant="body2" sx={{ flexShrink: 0}}> 
                                                {leftPercentage}%
                                            </Typography>
                                        </Box>*/}

                                        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 2 }}> 
                                            <Typography sx={{ flexShrink: 0 }}>
                                                {dict.big5Options[item.dictKey]?.right}
                                            </Typography>
                                                <Typography variant="body2" sx={{ flexShrink: 0 }}> 
                                                {leftPercentage}%
                                            </Typography>
                                        </Box>

                                    </Box>

                                    <Slider
                                        aria-label={`${item.key} proportion`}
                                        
                                        value={big5Values[item.key]}
                                        valueLabelDisplay="off"
                                        step={5}
                                        min={0}
                                        max={100}
                                        // marks
                                        // track={rightPercentage < 50 ? "normal":"inverted"}
                                        onChange={(e, value) => {
                                            updateBig5Values((prev) => ({
                                                ...prev,
                                                [item.key]: value,
                                            }));
                                    
                                            updateBotProfileBulk({
                                                profileObj: {
                                                    ...bot.profileObj,
                                                    longMem: {
                                                        ...bot.profileObj.longMem,
                                                        [item.key]: value,
                                                    },
                                                },
                                            });
                                        }}
                                    />
                                </Box>
                            )
                        })}
                    </Box>




                    {/* 性格（最大6組） */}
                    <Texts.H6>{dict["personality"]}</Texts.H6>
                    <Texts.Paragraph>
                        {dict["personalityHelpingText"]}
                    </Texts.Paragraph>

                    <KeyValuePairs
                        targetTheme={dict["personalityTargetTheme"]}
                        inputJsonArr={personalityObj}
                        enableCustomType={true}
                        predefinedTypes={dict["personalityTypeOptions"]}
                        useAutocomplete={true}
                        typeLabel={dict["typeLabel"]}
                        detailLabel={dict["detailLabel"]}
                        maxWarning={dict["maxWarning"]}
                        deleteWarning={dict["deleteWarning"]}
                        cancelText={dict["cancelText"]}
                        yesText={dict["yesText"]}
                        onUpdateArr={(newArr) => {
                            // setPersonalityObj(newArr)
                            updateBotProfileBulk({
                                profileObj: {
                                    personality: BotHelper.convertJsonToYmlString(newArr),
                                    personalityObj: newArr
                                }
                            });
                        }}
                    />

                    <Stack
                        spacing={4}
                        direction={"row"}
                        justifyContent={"space-between"}
                    >
                        <Buttons.SecondaryButton
                            onClick={() => {
                                history.push("/profilesetup/demo-profile")
                                setSelectedDot(1)
                            }}
                        >
                            {dict["prev"]}
                        </Buttons.SecondaryButton>
                        <Buttons.Button
                            onClick={async () => {
                                const errors = isValidData();
                                if (Object.keys(errors).length > 0) {
                                    showFirstError(errors)
                                }
                                else {
                                    const isValid = await isBig5Valid(big5Values);
                                    if (isValid) {
                                    //    updateBotProfileBulk({
                                    //         profileObj: {
                                    //             story: BotHelper.convertJsonToYmlString(story),
                                    //             background: BotHelper.convertJsonToYmlString(background),
                                    //             personality: BotHelper.convertJsonToYmlString(personality),
                                    //             storyObj: story,
                                    //             backgroundObj: background,
                                    //             personalityObj: personality,
                                    //         }
                                    //     })
                                        history.push("/profilesetup/health-data")
                                        setSelectedDot(3)
                                    }
                                }
                            }}
                        >
                            {dict["next"]}
                        
                        </Buttons.Button>

                    </Stack>

                </Stack>
            </Grid>
        </Grid>

    </React.Fragment>)
}

export default LifeDetails
